import { defineMessages } from 'react-intl';

export default defineMessages({
  successfulyUploadedWatermark: {
    id: 'component.watermark.sucessfulyUploaded',
    defaultMessage: 'Sucessfully uploded a new watermark.',
  },
});
